
import {
  Component,
  Vue
} from 'vue-property-decorator'
import {
  mask
} from 'vue-the-mask'
import CollectionService from '../../../../services/collection-service'
import {
  JobModule
} from '../../../../store/JobModule'
import {
  AuthModule
} from '@/store/modules/AuthModule'
import {
  ToastModule
} from '@/store/modules/ToastModule'
import {
  Validations
} from 'vuelidate-property-decorators'
import {
  Vuelidate
} from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'
import {
  NotifyModule
} from '@/store/modules/NotifyModule'
  @Component({
    name: 'JobMode',
    directives: {
      mask
    }
  })
export default class JobMode extends Vue {
    protected isTableBusy = false
    protected isEdit = false
    protected isSchedule = false
    protected barges: any = []
    protected trucks: any = []
    protected items: any = []
    protected fields: any = [{
      key: 'barge',
      label: 'Barge',
      thStyle: {
        width: '15%'
      }
    },
    {
      key: 'no_of_trips',
      label: 'No of Trips',
      thStyle: {
        width: '5%'
      }
    },
    {
      key: 'rob',
      label: 'ROB',
      thStyle: {
        width: '5%'
      }
    },
    {
      key: 'action',
      label: '',
      thStyle: {
        width: '5%'
      },
      class: 'text-center'
    }
    ]

    $v: Vuelidate

    @Validations()
    validations = {
      items: {
        $each: {
          no_of_trips: {
            required
          }
        }
      }
    }

    mounted () {
      this.items = this.items.map(items => ({
        ...items,
        isEdit: true
      }))
    }

    get job () {
      return JobModule.job
    }

    created () {
      this.boot()
    }

    private boot () {
      this.populateMode()
      this.populateBarge()
    }

    private populateBarge () {
      CollectionService.getBargeNames().then((response) => {
        response.data.forEach((barge) => {
          this.barges.push({
            value: {
              id: barge.id,
              name: barge.name,
              capacity: barge.capacity,
              rob: barge.balance_quantity
            },
            text: barge.name
          })
        })
      })
    }

    protected populateMode () {
      this.isTableBusy = true
      CollectionService.getAllocatedBarge(this.job.id).then((response) => {
        this.isTableBusy = false
        if (response.data.length === 0) {
          this.items.push({
            isEdit: true,
            id: null,
            barge: {},
            old_barge: {},
            no_of_trips: null,
            created_user: AuthModule.user.fullname,
            modified_user: AuthModule.user.fullname
          })
        } else {
          this.items = response.data.map((item: any) => ({
            ...item,
            barge: {
              id: item.barge_id,
              name: item.barge_name,
              capacity: item.capacity,
              rob: item.balance_quantity
            },
            old_barge: {
              id: item.barge_id,
              name: item.barge_name,
              capacity: item.capacity,
              rob: item.balance_quantity
            },
            modified_user: AuthModule.user.fullname
          }))
        }
      })
    }

    protected isNumber ($event: any) {
      const charCode = ($event.keyCode ? $event.keyCode : $event.which)
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        $event.preventDefault()
      } else {
        return true
      }
    }

    protected editRowHandler (data: any) {
      this.items[data.index].isEdit = !this.items[data.index].isEdit
    }

    protected addLine () {
      this.items = this.items.map(item => ({
        ...item
      }))
      this.items.push({
        id: null,
        barge: {},
        no_of_trips: null,
        created_user: AuthModule.user.fullname,
        modified_user: AuthModule.user.fullname
      })
    }

    protected checkROB (index) {
      if (this.items[index].barge.rob === this.items[index].barge.capacity) {
        this.items[index].barge = {}
        return NotifyModule.set('ROB exceeds barge capacity, Please select any other barge..')
      }
    }

    protected isValidated () {
      const unassignedCount = this.items.filter(item => Object.keys(item.barge).length === 0).length
      if (unassignedCount !== 0) {
        NotifyModule.set('Barge is not assigned, Please check...')
        return false
      }

      this.$v.$touch()
      if (this.$v.$invalid) {
        NotifyModule.set('Some fields are missing, Please check...')
        return false
      }

      const barge = this.items.map(item => item.barge.id)
      const isDuplicate = barge.some((item, index) => {
        return barge.indexOf(item) !== index
      })
      if (isDuplicate) {
        NotifyModule.set('Barge cannot be duplicated..')
        return false
      }

      return true
    }

    private async checkIfActivitiesExist (item) {
      if (Object.keys(item.old_barge || {}).length !== 0) {
        if (await this.checkActivitiesExist(item.old_barge.id)) {
          item.barge = item.old_barge
          return NotifyModule.set('Cannot change the allocated barge, as activities are already created..')
        }
      }
    }

    private async checkActivitiesExist (bargeId) {
      const response = await CollectionService.checkActivitiesExist(this.job.id, bargeId)
      return response.data
    }

    public save () {
      if (!this.isValidated()) return false
      const job = {
        id: this.job.id,
        vessel_arrival_date: this.job.vessel_arrival_date,
        vessel_arrival_time: this.job.vessel_arrival_time
      }
      const lines: any = []
      this.items.forEach((item) => {
        lines.push({
          id: item.id,
          job_id: this.job.id,
          barge_id: item.barge.id,
          barge_name: item.barge.name,
          no_of_trips: item.no_of_trips,
          created_user: AuthModule.user.fullname,
          modified_user: AuthModule.user.fullname
        })
      })
      CollectionService.save(job, lines).then((response) => {
        ToastModule.message(response.data.message)
        if (this.isSchedule) this.scheduleOperation()
        this.populateMode()
        // JobModule.setJob(JobModule.job.id)
      }).catch(error => {
        this.isSchedule = false
        ToastModule.message(error.response.data.message)
      })
    }

    protected scheduleForOperation () {
      if (!this.isValidated()) return false
      this.isSchedule = true
      this.save()
    }

    protected scheduleOperation () {
      const job = {
        job_id: JobModule.job.id,
        type: 'attend',
        added_date: new Date().toJSON().slice(0, 10),
        created_user: AuthModule.user.fullname,
        modified_user: AuthModule.user.fullname
      }
      CollectionService.scheduleOperation(job).then((response) => {
        ToastModule.message(response.data.message)
        JobModule.setJob(JobModule.job.id);
        (this.$parent as any).populateJobScheduleStatus()
        this.isSchedule = false
      }).catch(error => {
        console.log(error)
      })
    }

    protected async deleteLine (tableIndex: number, item: any) {
      if (item.id === null) {
        this.items.splice(tableIndex, 1)
      } else {
        if (await this.checkActivitiesExist(item.barge.id)) return NotifyModule.set('Cannot delete the allocated barge, as activities are already created..')
        else if (confirm(`Are you sure you want to delete this Barge ${item.barge.name}?`) === true) {
          CollectionService.deleteBarge(this.job.id, item.barge.id).then((response) => {
            this.items.splice(tableIndex, 1)
            ToastModule.message(response.data.message)
          }).catch(error => {
            ToastModule.message(error.response.data.message)
          })
        }
      }
    }

    protected cancel () {
      this.items = []
      this.populateMode()
    }
}

